 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      GL Analysis Code List
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryGlAnCodeFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAnCodeFilterForm"
                            v-model="filtersGlAnCode.glAnCode"
                            :label="filtersGlAnCodeLabel.glAnCode"
                            :error-messages="errors.collect('filterClm')"
                            data-vv-name="filterClm"
                            :data-vv-as="filtersGlAnCodeLabel.glAnCode"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearGLAnCodeFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doGlAnCodelFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="glAnCodeHeaders"
          :items="glAnCodeItems"
          v-bind:options.sync="paginationGlAnCode"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsGlAnCode"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.glanCode }}</td>
              <td>{{ row.item.glanType }}</td>
              <td>{{ row.item.glanDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click="assignGlAnCode(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      glAnCodeItems: [],
      totalItemsGlAnCode: 0,
      filtersGlAnCodeLabel: {
        glAnCode: 'GL Analysis No.'
      },
      filtersGlAnCode: {
        glAnCode: undefined
      },
      glAnCodeHeaders: [
        { text: 'Gl An Code.', align: 'left', value: 'glAnCode' },
        { text: 'GL An Type.', align: 'left', value: 'glAnType' },
        { text: 'Description.', align: 'left', value: 'glAnDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationGlAnCode: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearGLAnCodeFilters()
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearGLAnCodeFilters()
      }
    },
    'paginationGlAnCode': function (value) {
      this.fetchGLAnCodeData()
    }
  },
  methods: {
    closeDialog() {
      this.filtersGlAnCode.glAnCode = ''
      this.$emit('close')
    },
    doClearGLAnCodeFilters() {
      this.filtersGlAnCode.glAnCode = ''
      this.fetchGLAnCodeData()
    },
    doGlAnCodelFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryGlAnCodeFilterForm').then((result) => {
        if (result) {
          this.paginationGlAnCode.page = 1
          this.fetchGLAnCodeData()
        }
      })
    },
    assignGlAnCode(data) {
      this.$emit('assign-gl-an-code', data)
      this.$emit('close')
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
